module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "addInstance",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [(this.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Add The Host In Bulk")]) : _vm._e(), _vm._v(" "), (this.$route.query.type === 'rds') ? _c('translate', [_vm._v("Add The Database In Bulk")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-row', {
    staticClass: "step"
  }, [_c('el-col', {
    staticClass: "step-title",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("First Step")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "step-text",
    attrs: {
      "span": 18
    }
  }, [(this.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Download The Host List, Fill In The Host Information")]) : _vm._e(), _vm._v(" "), (this.$route.query.type === 'rds') ? _c('translate', [_vm._v("Download The Database List, Fill In The Database Information")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "down-load",
    attrs: {
      "href": _vm.downUrl
    },
    on: {
      "click": _vm.onDownUrl
    }
  }, [_c('translate', [_vm._v("Download")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "step"
  }, [_c('el-col', {
    staticClass: "step-title secont-title",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Second Step")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "step-text",
    attrs: {
      "span": 18
    }
  }, [(this.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Upload The Host List")]) : _vm._e(), _vm._v(" "), (this.$route.query.type === 'rds') ? _c('translate', [_vm._v("Upload The Database List")]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.$refs['upload-file'].onClick()
      }
    }
  }, [_c('file-base64', {
    ref: "upload-file",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "progress": _vm.onProgress,
      "done": _vm.uploadFiles
    }
  })], 1), _vm._v(" "), (_vm.fileInfo) ? _c('ul', {
    staticClass: "upload-list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('el-row', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('el-col', {
    staticClass: "word-wrap",
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.fileInfo.name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_vm._v(_vm._s(((_vm.fileInfo.size / 1000) + "kB")))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('a', {
    staticClass: "close-file",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCloseFile
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-times-circle-o"
  })])])], 1), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.progress,
      "show-text": false,
      "stroke-width": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "err-code"
  }, [_vm._v("\n              " + _vm._s(_vm.errMsg) + "\n            ")])], 1)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.fileInfo && _vm.progress !== 100
    },
    on: {
      "click": function($event) {
        _vm.onUpload()
      }
    }
  }, [_c('translate', [_vm._v("Upload")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.addInstance.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-462af3c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-batch-instances.vue
// module id = 557
// module chunks = 4 5 6